// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"a24e8a68c79950f31eed","159":"753b844ff66da05cc1c1"}[chunkId] + ".js";
};